import React, { Component } from 'react';

import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';

import {
    FormInput,
} from 'wanderu-component-form';
import {
    filterResultsWithGooglePlaceIds,
} from 'wanderu-service-google';
import { generateFakeOnChangeEvent } from 'wanderu-utils';

import InputDropdown from '../InputDropdown/InputDropdown';
import Options from '../Options/Options';

export default class PlaceDropdown extends Component {
    static propTypes = {
        autoComplete: PropTypes.string,
        className: PropTypes.string,
        clearable: PropTypes.bool,
        dataset: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            text: PropTypes.string,
        })),
        formId: PropTypes.string,
        inputClass: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onOptionChange: PropTypes.func,
        optional: PropTypes.bool,
        optionsClass: PropTypes.string,
        placeholder: PropTypes.string,
        poweredByGoogle: PropTypes.bool,
        readOnly: PropTypes.bool,
        showInputCaret: PropTypes.bool,
        showValidity: PropTypes.bool,
        valid: PropTypes.bool,
        value: PropTypes.string,
    };

    static defaultProps = {
        clearable: true,
        dataset: [],
        inputClass: '',
        onBlur() {},
        onChange() {},
        onFocus() {},
        onOptionChange() {},
        optionsClass: '',
        poweredByGoogle: true,
        readOnly: false,
        showInputCaret: true,
        value: '',
    };

    constructor(props) {
        super(props);

        const {
            dataset,
            value,
        } = this.props;
        const selectedOption = this.getOptionInDataset(value, dataset);

        this.state = {
            inputText: value,
            options: dataset,
            selectedOption: selectedOption || {},
            sessiontoken: uuidV4(),
        };

        this.needToReconcileOptions = !!value;
    }

    // eslint-disable-next-line camelcase
    async UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            dataset,
            value,
        } = nextProps;

        if (value !== this.props.value) {
            return this.reconcileOption(value, dataset);
        }

        if (dataset !== this.props.dataset) {
            if (this.needToReconcileOptions) {
                this.needToReconcileOptions = false;
                const newDataset = await this.getOptions(this.state.inputText, nextProps.dataset);
                return this.reconcileDataset(newDataset);
            }
            return this.reconcileDataset(dataset);
        }
        return undefined;
    }

    async reconcileOption(value, dataset) {
        this.updateOption(value, dataset);

        const option = this.getOptionInDataset(value, dataset) || {};
        const newDataset = await this.getOptions(option.text, dataset);
        this.reconcileDataset(newDataset, value);
    }

    reconcileDataset(dataset, value = this.state.inputText) {
        this.updateOption(value, dataset);
        this.setState(() => ({ options: dataset }));
    }

    getOptionInDataset(value, dataset) {
        let dataSetToSearch = dataset;

        if (!dataSetToSearch.length) {
            dataSetToSearch = this.state?.options || [];
        }

        return dataSetToSearch.find((item) => {
            const idMatch = item.id === value;
            const textMatch = item.text === value;
            return idMatch || textMatch;
        });
    }

    updateOption(value, dataset) {
        const option = this.getOptionInDataset(value, dataset);
        const selectedOption = option || {};

        if (this.state.selectedOption.id === selectedOption.id) {
            return;
        }

        this.setState(() => ({
            inputText: selectedOption.text || '',
            selectedOption,
            sessiontoken: uuidV4(),
        }));

        const fakeChangeEvent = generateFakeOnChangeEvent(undefined, selectedOption.id);
        this.props.onChange(fakeChangeEvent);

        const fakeOptionChangeEvent = generateFakeOnChangeEvent(undefined, option);
        this.props.onOptionChange(fakeOptionChangeEvent);
    }

    onInputChange = async (e) => {
        const inputText = e.target.value;
        this.setState(() => ({ inputText }));
        const options = await this.getOptions(inputText, this.props.dataset);
        this.setState(() => ({ options }));
    };

    async getOptions(inputText, dataset) {
        const {
            poweredByGoogle,
        } = this.props;

        if (!inputText || !poweredByGoogle) {
            return dataset;
        }

        const { sessiontoken } = this.state;
        const value = inputText.toLowerCase();

        return filterResultsWithGooglePlaceIds(value, dataset, { sessiontoken });
    }

    onOptionSelected = async (e) => {
        let option = e.target.value || {};

        const oldSessionToken = this.state.sessiontoken;
        this.setState(() => ({
            inputText: option.text,
            selectedOption: option,
            sessiontoken: uuidV4(),
        }));

        const fakeChangeEvent = generateFakeOnChangeEvent(e, option.id);
        this.props.onChange(fakeChangeEvent);
        return this.props.onOptionChange(e, oldSessionToken);
    };

    render() {
        return (
            <InputDropdown
                className={this.props.inputClass}
                onBlur={this.props.onBlur}
                onChange={this.onOptionSelected}
                onFocus={this.props.onFocus}
                onInputChange={this.onInputChange}
                optional={this.props.optional}
                options={this.state.options}
                value={this.state.inputText}
            >
                <FormInput
                    autoComplete={this.props.autoComplete}
                    className={this.props.className}
                    clearable={this.props.clearable}
                    id={this.props.formId}
                    placeholder={this.props.placeholder}
                    readOnly={this.props.readOnly}
                    showInputCaret={this.props.showInputCaret}
                    showValidity={this.props.showValidity}
                    valid={this.props.valid}
                />
                <Options
                    className={this.props.optionsClass}
                    poweredByGoogle={this.props.poweredByGoogle}
                    substringMatch
                />
            </InputDropdown>
        );
    }
}
